import React, { forwardRef } from 'react'
import { LinkList as HdsLinkList, Link } from '@postenbring/hedwig-react'
import './link-list.scss'

export interface LinkListProps {
    links: Array<{
        link: string
        linkText: string
        target?: string
    }>
    size?: 'default' | 'small' | 'technical';
}

export const LinkList = ({ links, size }: LinkListProps) => {

    return (
        <HdsLinkList size={size || 'default'} className='hds-mb-20-24'>
            {links.map((link, index) => (
                <li key={index}>
                    <Link
                        href={link.link}
                        target={link.target}
                    >
                        {link.linkText}
                    </Link>
                </li>
            ))
            }
        </HdsLinkList>
    )
}

